import { useRef, useState } from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useReactToPrint } from "react-to-print";
import { Card } from "primereact/card";
import html2pdf from "html2pdf.js";

export const DefeitoDiario = ({ data, totalGeral, date }) => {
    const ref = useRef();
    const [printing, setPrinting] = useState(false);

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                setPrinting(true);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        },
        onAfterPrint: () => {
            setPrinting(false);
        }
    });

    const handlePdf = () => {
        const element = ref.current;
        
        const opt = {
            margin: 10,
            filename: `Relatorio_Defeitos_${date || 'diario'}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        setPrinting(true);

        html2pdf().set(opt).from(element).save().then(() => {
            setPrinting(false);
        });
    };

    const formatNumber = (num) => {
        if (num === null || num === undefined) return "0,00";
        return parseFloat(num).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    if (!data || data.length === 0) return null;

    return (
        <div>
            <Card>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                    <Button 
                        className="p-button-primary"
                        icon="pi pi-print"
                        onClick={handlePrint}
                    />
                    <Button 
                        className="p-button-danger"
                        icon={printing ? "pi pi-spin pi-spinner" : "pi pi-file-pdf"}
                        onClick={handlePdf}
                        disabled={printing}
                    />
                </div>
                <div ref={ref} style={{ width: printing ? '90%' : '70%', marginLeft: printing ? '5%' : '15%', marginRight: printing ? '5%' : '15%'}}>
                    <h2>Relatório Diário de Defeitos - {date}</h2>
                    {data.map((item, index) => (
                        <div key={index} style={{ marginBottom: '2.5rem', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.03)', border: '1px solid #e0e0e0'}}>
                            <h4 style={{ fontSize: '18px', margin: 0, padding: '12px', borderBottom: '2px solid #2196F3', display: 'flex',  justifyContent: 'space-between', alignItems: 'center'}}>
                                {item.setor}
                            </h4>
                            
                            <div style={{ margin: printing ? '25px' : '20px 50px'}}>
                                <DataTable
                                    responsiveLayout="scroll"
                                    style={{ fontSize: 15 }}
                                    size="small"
                                    value={item.defeitos}
                                    rowHover={true}
                                >
                                    <Column header="Defeito" field="defeito" style={{ width: '120px' }} sortable />
                                    <Column header="Metragem (m)" field="metragem" body={(rowData) => formatNumber(rowData.metragem)} style={{ width: '120px' }} sortable />
                                </DataTable>

                                <div className="p-p-2" style={{ fontWeight: 'bold', fontSize: '18px'}}>
                                    Total: {formatNumber(item.total_defeito)}m
                                </div>
                            </div>
                            
                        </div>
                    ))}

                    <div className="p-mt-4 p-p-3 p-text-right" style={{ fontSize: '20px', fontWeight: '700',  backgroundColor: '#f1f5f9', borderRadius: '8px', padding: '20px', border: '2px solid #e2e8f0',}}>
                        <span>Total Geral: <span style={{ color: '#0c6ab6' }}>{formatNumber(totalGeral)}m</span></span>
                    </div>

                </div>
            </Card>
        </div>
    );
}